import { put, takeEvery, call } from 'redux-saga/effects';
import { LoginActions } from './actions';
import ApiService from '../../../Services/ApiService';
import { displayNotification } from '../../../Utils/GenericUtils';

export function* submitLogin(action) {
  try {
    const { email, password, remember, captcha, deviceToken, next } = action.payload;
    const res = yield call(ApiService.login, { email, password, remember, captcha, deviceToken, next });
    const data = res.data || res;
    if (data.requires_captcha) {
      yield put(LoginActions.setRequiresCaptcha(true));
      yield put(LoginActions.submitLoginFailed({}));
      return;
    }
    yield put(LoginActions.submitLoginSucceeded());
    window.location = data.redirect_url || '/';
  } catch (e) {
    const data = e?.response?.data || {};
    yield put(LoginActions.submitLoginFailed(data));
    if (data.error === 'sso_required') {
      displayNotification('error', 'Error', "Please log in with your organization's single sign-on.");
    }
  }
}

export function* watchLogin() {
  yield takeEvery(LoginActions.submitLogin, submitLogin);
}
